import { isPC } from "@modules/util/device"
import { registerGlobalEventListener } from "@modules/util/events.ts"
import { createNewPathForLocationSlug } from "@modules/util/url"
export function updateLocationLinks(seoUrl: string) {
    const locationLinks = document.querySelectorAll<HTMLAnchorElement>("[data-location-slug]")
    for (const locationLink of locationLinks) {
        const citySlug = locationLink.getAttribute("data-location-slug") || ""
        locationLink.href = createNewPathForLocationSlug(seoUrl, citySlug)
    }
    updateAllRegionsLink()
    if (isPC()) {
        updateCityAdressesLinksPc(seoUrl)
    }
}

function updateCityAdressesLinksPc(seoUrl: string) {
    const addressLinks = document.querySelectorAll<HTMLAnchorElement>(".adressenwahl a[data-eaid]")
    for (const addressLink of addressLinks) {
        const addressId = addressLink.getAttribute("data-eaid") || ""
        const url = new URL(seoUrl)
        if (addressId) {
            url.searchParams.set("adresse", addressId)
        } else {
            url.searchParams.delete("adresse")
        }
        addressLink.href = url.href
    }
}

function updateAllRegionsLink() {
    const allRegionsLink = document.getElementById("all-regions-link")
    if (allRegionsLink instanceof HTMLAnchorElement) {
        allRegionsLink.href = createNewPathForLocationSlug(window.location.href, "")
    }
}
registerGlobalEventListener("azm.filter-api.after-fetch", (event) => {
    updateLocationLinks(event.detail.seoUrl)
})

updateLocationLinks(window.location.href)
